<template>
  <div class="double-card-page-container mdl-shadow--2dp"  >
    <div class="mdl-card fill">
      <div class="mdl-card__title">
        <h2 class="mdl-card__title-text">{{'admin.subscriptions.label.title' | label}}</h2>
      </div>
      <div class="mdl-card__supporting-text fill">
        <data-table
          page="subscriptions"
          :data.sync="subscriptions"
          :selectable="table.selectable"
          :columns="table.columns"
          :sort="table.sort"
          :filter="table.filter">
          <div slot="actions">
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                 v-on:click="cancelSubscription()">{{ 'admin.subscriptions.button.cancel' | label}}</div>
            <div class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored"
                 v-on:click="showHistory()">{{ 'admin.subscriptions.button.showHistory' | label}}</div>
          </div>
          <div slot="empty">
            <div class="empty-message">
              {{ 'admin.subscriptions.label.nosubscriptions' | label }}
            </div>
          </div>
        </data-table>
      </div>
    </div>
  </div>
</template>

<script>
  var api = require('api')
  var payment = require('api/Payment')
  var momentTz = require('moment-timezone')
  var makeDate = require('vue').filter('makeDate')
  module.exports = {
    ready: function () {
      this.findSubscriptions()
    },
    components: {
      dataTable: require('c/components/Table')
    },
    methods: {
      findSubscriptions: function () {
        var self = this
        api.User.findWithSubscription().then(function (response) {
          var users = response.data
          if (users) {
            self.subscriptions = []
          }
          users.forEach(function (user) {
            var pSubscription = {
              nickname: user.nickname,
              id: user.id,
              userId: user.id,
              end: makeDate(user.Subscription.billingPeriodEndDate, momentTz.tz.guess(), 'DD MMM YYYY HH:mm'),
              start: makeDate(user.Subscription.billingPeriodStartDate, momentTz.tz.guess(), 'DD MMM YYYY HH:mm'),
              status: user.Subscription.status,
              billingPeriodCode: user.Subscription.billingPeriodCode,
              paymentMethod: user.Subscription.paymentMethod,
              trialBurnt: user.Subscription.trialBurnt
            }
            self.subscriptions.push(pSubscription)
          })
        }, function (err) {
          if (err.status !== 404) {
            self.$dispatch('show-error', err.data)
          }
        })
      },
      cancelSubscription: function () {
        var self = this
        var ids = []
        self.subscriptions.forEach(function (subscription) {
          if (subscription.__checked) {
            ids.push(subscription.userId)
          }
        })
        payment.cancelSubscription(function (response) {
          self.$dispatch('show-success', 'admin.subscriptions.message.cancel.success')
          self.$broadcast('clear-select')
          self.findSubscriptions()
        }, function (err) {
          self.$dispatch('show-error', err.data)
        }, ids)
      },
      showHistory: function () {
        var self = this
        for (const subscription of self.subscriptions) {
          if (subscription.__checked) {
            self.$router.go('/admin/subscriptions/history/' + subscription.userId)
            break
          }
        }
      }
    },
    data: function () {
      return {
        table: {
          selectable: true,
          columns: ['nickname', 'paymentMethod', 'start', 'end', 'status', 'billingPeriodCode', 'trialBurnt'],
          sort: [],
          filter: []
        },
        subscriptions: []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Subscriptions.vue?f79837ae